import './index.scss'
import './index-menu.scss'
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import  ResetAttributes  from '../../../general/ResetButton.js'

import { useState, useEffect } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

import { InspectorControls, PanelColorSettings } from '@wordpress/block-editor';
import {	
	PanelBody,	
	RangeControl,
  ToggleControl, 
  SelectControl,
  Flex,
  FlexItem
} from '@wordpress/components';


const allowedBlocks = [
  'core/navigation',
 
];
const anavDefaults = {
	aOn: false,
  type: '',
  underline: false,
  borderRadiusCheck: false,
  borderRadius: 0,
  separator: false,
  border: false,
  translate: false,
  colorHover: false,
  color: '',
  bgColor: '',
  paddingLeftRight: 0,
  paddingTopBottom: 0	
};


const addAttributes = ( settings, name ) => {

	if (!allowedBlocks.includes(name)) return settings;	

	if( typeof settings.attributes !== 'undefined' ){	
		settings.attributes = {
      ...settings.attributes,
      anav:{
        type: 'object',
				default: anavDefaults,
      }		
		}    
	}
	return settings;
}


const addInspectorControl = ( BlockEdit ) => ( props ) => {

  if (!allowedBlocks.includes(props.name)) return <BlockEdit {...props} />;

	const { attributes, setAttributes, isSelected } = props;
  const { anav = {}, overlayMenu } = attributes;

  if ( overlayMenu !== 'never') return <BlockEdit {...props} />;

  const orgDefaults = {
		...anavDefaults,
		...(attributes.anav || {}),
	};

	const { 
    aOn,
		type, 
    underline, 
    borderRadiusCheck, 
    borderRadius, 
    separator, 
    border, 
    color, 
    translate, 
    bgColor, 
    colorHover, 
    paddingLeftRight, 
    paddingTopBottom
	} = orgDefaults;

  const isDifferentFromDefault = JSON.stringify({ ...anav, aOn: undefined }) !== JSON.stringify({ ...anavDefaults, aOn: undefined });

	const updateObject = (obj, key, newVal) => ({ ...obj, [key]: newVal });
	const updateArray = (list, index, newVal) => {
		const listsCopy = [...list];
		listsCopy[index] = newVal;
		return listsCopy;
	}


  return (
    <>
      <BlockEdit {...props} />

        <InspectorControls group="settings">	
          
          <PanelBody title={__('Menu Type', 'aver')} initialOpen={ aOn }>

            <Flex>
              <FlexItem>
                <ToggleControl
                  label={__('Enable Nav Settings', 'aver')}
                  checked={aOn}
                  onChange={(val) => setAttributes({ anav: {...anav, aOn: val }})}
                />
              </FlexItem>
              <FlexItem>
                { isDifferentFromDefault && (
                  <ResetAttributes
                    onConfirm={() => {
                      setAttributes({
                        anav: anavDefaults
                      });								
                    }}
                  /> 
                )}
              </FlexItem>
            </Flex>		

            { aOn && <SelectControl
              label={ __( 'Menu Style', 'aver' ) }
              options={[
                { label: 'None', value: '' },
                { label: 'Top Menu', value: 'top-menu' },
                { label: 'Hover Menu', value: 'hover-menu' },
                { label: 'Vertical Menu', value: 'vertical-menu' },             
              ]}
              value={ type }
              onChange={ ( newval ) => setAttributes({anav : {...anav, type: newval } }) }
            /> }
          </PanelBody>

          {aOn && <>
            <PanelBody title={__('Top Menu Settings', 'aver')} initialOpen={ false }>

              <ToggleControl
                label={ __( 'Top Level Underline' ) }
                checked={ underline }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  underline: newval } }) }					
              /> 
                
              <RangeControl
                label={ __( 'Padding Left Right(px)', 'aver' ) }
                value={ paddingLeftRight  }
                min={ 0 }
                max={ 200 }
                step={ 1 }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  paddingLeftRight: newval } }) }					
              />

              <RangeControl
                label={ __( 'Padding Top Bottom(px)', 'aver' ) }
                value={ paddingTopBottom  }
                min={ 0 }
                max={ 200 }
                step={ 1 }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  paddingTopBottom: newval } }) }					
              />

            </PanelBody>

            <PanelBody title={__('Sub Menu Settings', 'aver')} initialOpen={ false }>
              <ToggleControl
                label={ __( 'Border Radius' ) }
                checked={ borderRadiusCheck }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  borderRadiusCheck: newval } }) }										
              />

              { borderRadiusCheck && <RangeControl
                label={ __( 'Border Radius(px)', 'aver' ) }
                value={ borderRadius }
                min={ 0 }
                max={ 100 }
                step={ 1 }              
                onChange={ ( newval ) => setAttributes({anav : {...anav,  borderRadius: newval } }) }					
              /> }

              <ToggleControl
                label={ __( 'Separator' ) }
                checked={ separator }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  separator: newval } }) }										
              />

              <ToggleControl
                label={ __( 'Border None' ) }
                checked={ border }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  border: newval } }) }									
              />

              <ToggleControl
                label={ __( 'Translate' ) }
                checked={ translate }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  translate: newval } }) }											
              />

              <ToggleControl
                label={ __( 'Hover Color' ) }
                checked={ colorHover }							
                onChange={ ( newval ) => setAttributes({anav : {...anav,  colorHover: newval } }) }									
              />


              
            </PanelBody>

            {colorHover && <PanelColorSettings
                title={ __( 'Sub Menu Hover Color Settings', 'aver' ) }
                icon="admin-appearance"
                initialOpen
                disableCustomColors={ false }
                enableAlpha={ true }
                colorSettings={ [
                  {
                    value: bgColor,
                    onChange: ( newval ) => setAttributes({anav : {...anav,  bgColor: newval } }) ,
                    label: __( 'Background Color', 'aver' ),
                  },
                  {
                    value: color,
                    onChange: ( newval ) => setAttributes({anav : {...anav,  color: newval } }) ,
                    label: __( 'Text Color', 'aver' ),
                  },
                ] }
              ></PanelColorSettings> }
          </> }
      </InspectorControls>
    </>
  )

}

const applyExtraClassEditor = ( BlockListBlock ) => ( props ) => {

    if ( ! allowedBlocks.includes( props.name ) ) {
      return ( 
        <BlockListBlock { ...props } />	
      );
    }  

    const { name, attributes, setAttributes, wrapperProps, className } = props;
    const { anav = {}} = attributes;
    const orgDefaults = {
      ...anavDefaults,
      ...(attributes.anav || {}),
    };

    const { 
      aOn,
      type, 
      underline, 
      borderRadiusCheck, 
      borderRadius, 
      separator, 
      border, 
      color, 
      translate, 
      bgColor, 
      colorHover, 
      paddingLeftRight, 
      paddingTopBottom
    } = orgDefaults;

    // clean up the attributes saved in database
    useEffect(() => {
      if (!allowedBlocks.includes(name)) return;
      if (!anav) return;

      const updatedata = {};
      for (const key in anav) {
        const val = anav[key];
        const def = anavDefaults[key];

        if (val === undefined) continue;
        if (JSON.stringify(val) !== JSON.stringify(def) && val !== '') {
          updatedata[key] = val;
        }
      }

      // Prevent loop by comparing current and cleaned data
      if (JSON.stringify(updatedata) !== JSON.stringify(anav)) {
        setAttributes({ anav: updatedata });
      }
    }, [name, JSON.stringify(anav)]);
    
    const cssstyle = { 
			...wrapperProps?.style,
      ...( color != '' && colorHover && { '--acolor': color }),
      ...( bgColor != '' && colorHover && { '--abgColor': bgColor }),
      ...( borderRadius != '' && borderRadiusCheck && { '--aborderRadius':  borderRadius + 'px' }),
      ...( paddingLeftRight != '' && { '--apaddingLeftRight':  paddingLeftRight + 'px' }),
      ...( paddingTopBottom != '' && { '--apaddingTopBottom':  paddingTopBottom  + 'px'}),
		}		
		 
  
    const classes = classnames(
      className, ``,
      {
        'aunderline': underline,      
        'aborderRadiusCheck': borderRadiusCheck, 
        'aseparator': separator,             
        'aborder': border,   
        'atranslate': translate, 
        'acolorHover': colorHover, 
        [`a${type}`]: type        
      }
    );	

    return (
			<BlockListBlock
				{ ...props }
				wrapperProps={ { style : cssstyle } } 	
				className={ classes }
			/>
		);
}







addFilter(
  'blocks.registerBlockType',
  'aver/anav-attributes',
  addAttributes
);

addFilter(
  'editor.BlockEdit',
  'aver/anav-advanced-control',
  addInspectorControl
);

addFilter(
  'editor.BlockListBlock',
  'aver/anav-editor-class',
  applyExtraClassEditor,
);


